'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var declaration = '#JSGF';

exports.default = function (_ref) {
	var version = _ref.version,
	    encoding = _ref.encoding,
	    lang = _ref.lang;
	return [declaration, version, encoding, lang].filter(Boolean).join(' ');
};


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/stringify/header.js
// module id = 237
// module chunks = 0